import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './mobilenumber.css';

const COUNTRY_CODES = [
  { code: '+91', country: 'IN' },
  { code: '+1', country: 'US' },
  { code: '+44', country: 'UK' },
  { code: '+971', country: 'UAE' },
];

export default function MobileNumber() {

  const navigate = useNavigate();

  const [countryCode, setCountryCode] = useState('+91');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [loading, setLoading] = useState(false);


  // =====================================================
  // MOBILE NUMBER CHANGE
  // =====================================================

  const handlePhoneChange = (e) => {

    const formattedVal = e.target.value
      .replace(/\D/g, '')
      .slice(0, 10);

    setPhoneNumber(formattedVal);
  };


  // =====================================================
  // GENERATE 6-DIGIT OTP
  // =====================================================

  const generateOTP = () => {

    const otp = String(
      Math.floor(
        100000 +
        Math.random() * 900000
      )
    );

    return otp;
  };


  // =====================================================
  // SAVE MOBILE NUMBER + GENERATE OTP
  // =====================================================

  const handleSubmit = async (e) => {

    e.preventDefault();


    // ---------------------------------------------------
    // Validate mobile
    // ---------------------------------------------------

    if (phoneNumber.length !== 10) {

      alert(
        'Please enter a valid 10-digit mobile number.'
      );

      return;
    }


    // Prevent double click
    if (loading) {
      return;
    }


    setLoading(true);


    try {

      // =================================================
      // Get existing user ID
      // =================================================

      const userId =
        localStorage.getItem('user_id');


      // =================================================
      // Get existing device UUID
      // =================================================

      const deviceUUID =
        localStorage.getItem('device_uuid');


      if (!userId && !deviceUUID) {

        alert(
          'User information not found. Please restart onboarding.'
        );

        setLoading(false);

        return;
      }


      // =================================================
      // Full mobile number
      // =================================================

      const fullMobileNumber =
        `${countryCode}${phoneNumber}`;


      console.log(
        'Saving Mobile Number:',
        fullMobileNumber
      );


      // =================================================
      // GENERATE NEW 6-DIGIT OTP
      // =================================================

      const generatedOtp =
        generateOTP();


      // =================================================
      // SAVE OTP LOCALLY
      // =================================================

      localStorage.setItem(
        'generated_otp',
        generatedOtp
      );


      // =================================================
      // SAVE OTP GENERATION TIME
      // =================================================

      localStorage.setItem(
        'otp_generated_at',
        String(Date.now())
      );


      // =================================================
      // SAVE MOBILE NUMBER LOCALLY
      // =================================================

      localStorage.setItem(
        'mobile_number',
        fullMobileNumber
      );


      console.log(
        'Generated OTP:',
        generatedOtp
      );


      // =================================================
      // API CALL
      // =================================================

      const response = await fetch(
        'https://coinyoco.world/brobizee-api/update_user.php',
        {
          method: 'POST',

          headers: {
            'Content-Type': 'application/json'
          },

          body: JSON.stringify({

            user_id: userId,

            device_uuid: deviceUUID,

            mobile_number: fullMobileNumber

          })
        }
      );


      // =================================================
      // HTTP CHECK
      // =================================================

      if (!response.ok) {

        throw new Error(
          `HTTP Error: ${response.status}`
        );
      }


      // =================================================
      // JSON RESPONSE
      // =================================================

      const result =
        await response.json();


      console.log(
        'Mobile API Response:',
        result
      );


      // =================================================
      // SUCCESS
      // =================================================

      if (result.success) {

        // Keep user ID
        if (result.user_id) {

          localStorage.setItem(
            'user_id',
            String(result.user_id)
          );
        }


        // Make sure mobile is saved
        localStorage.setItem(
          'mobile_number',
          fullMobileNumber
        );


        // =================================================
        // GO TO OTP PAGE
        // =================================================

        navigate('/otp-verification');

      } else {

        alert(
          result.message ||
          'Mobile number save nahi hua.'
        );

      }

    } catch (error) {

      console.error(
        'Mobile API Error:',
        error
      );

      alert(
        'Server se connection nahi ho raha.'
      );

    } finally {

      setLoading(false);
    }
  };


  const isValid =
    phoneNumber.length === 10;


  return (

    <div className="mobile-page-wrapper">

      <div className="mobile-app-card">

        {/* Ambient Background */}

        <div className="mobile-ambient mobile-ambient-one"></div>
        <div className="mobile-ambient mobile-ambient-two"></div>


        {/* Header */}

        <header className="mobile-header">

          <button
            type="button"
            className="mobile-back-btn"
            aria-label="Go Back"
            onClick={() => navigate(-1)}
          >

            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >

              <path d="M15 18l-6-6 6-6" />

            </svg>

          </button>


          <div className="mobile-step-indicator">

            <span className="step-dot active"></span>
            <span className="step-dot"></span>
            <span className="step-dot"></span>
            <span className="username-progress-dot"></span>

          </div>

        </header>


        {/* Main Content */}

        <main className="mobile-content">

          <div className="mobile-icon-wrapper">

            <div className="mobile-icon">

              <svg
                width="30"
                height="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.7"
                strokeLinecap="round"
                strokeLinejoin="round"
              >

                <rect
                  x="6"
                  y="2"
                  width="12"
                  height="20"
                  rx="2.5"
                />

                <path d="M10 5h4" />

                <circle
                  cx="12"
                  cy="18"
                  r="1"
                />

              </svg>

            </div>

          </div>


          <div className="mobile-title-group">

            <span className="mobile-eyebrow">
              LET'S GET STARTED
            </span>

            <h1 className="mobile-title">
              Your mobile
              <span> number</span>
            </h1>

            <p className="mobile-subtitle">
              Enter your mobile number to continue
              securely with BroBizee.
            </p>

          </div>


          {/* Phone Form */}

          <form
            id="mobile-form"
            onSubmit={handleSubmit}
            className="phone-form"
          >

            <label className="phone-label">
              Mobile Number
            </label>


            <div
              className={`phone-input-container ${
                phoneNumber.length === 10
                  ? 'phone-valid'
                  : ''
              }`}
            >

              {/* Country Code */}

              <div className="country-code-selector">

                <select
                  value={countryCode}
                  onChange={(e) =>
                    setCountryCode(e.target.value)
                  }
                  className="country-select"
                  aria-label="Country code"
                  disabled={loading}
                >

                  {COUNTRY_CODES.map((item) => (

                    <option
                      key={item.code}
                      value={item.code}
                    >
                      {item.code}
                    </option>

                  ))}

                </select>


                <span className="country-arrow">

                  <svg
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >

                    <path d="M6 9l6 6 6-6" />

                  </svg>

                </span>

              </div>


              <div className="country-divider"></div>


              {/* Phone Number */}

              <input
                type="tel"
                inputMode="numeric"
                autoComplete="tel"
                placeholder="XXX XXX XXX X"
                value={phoneNumber}
                onChange={handlePhoneChange}
                className="phone-input"
                maxLength={10}
                required
                disabled={loading}
              />


              {/* Valid Indicator */}

              {isValid && (

                <div className="valid-indicator">

                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >

                    <path d="M5 12l4 4L19 6" />

                  </svg>

                </div>

              )}

            </div>


            <div className="phone-helper">

              <span className="security-icon">

                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >

                  <rect
                    x="5"
                    y="11"
                    width="14"
                    height="10"
                    rx="2"
                  />

                  <path d="M8 11V7a4 4 0 018 0v4" />

                </svg>

              </span>

              <span>
                Your number is securely encrypted
              </span>

            </div>

          </form>


          {/* Bottom Action */}

          <div className="mobile-action-section">

            <p className="terms-disclaimer">

              By registering or signing in, you accept
              BroBizee's{' '}

              <a href="/privacy-policy_main">
                Terms & Conditions
              </a>{' '}

              and confirm that you've read and
              acknowledged our{' '}

              <a href="/privacy-policy_main">
                Privacy Policy
              </a>.

            </p>


            <button
              type="submit"
              form="mobile-form"
              className={`mobile-next-btn ${
                isValid ? 'enabled' : ''
              }`}
              aria-label="Continue"
              disabled={!isValid || loading}
            >

              <span>
                {loading
                  ? 'Saving...'
                  : 'Continue'}
              </span>


              <div className="mobile-next-arrow">

                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >

                  <path d="M5 12h14" />

                  <path d="M13 6l6 6-6 6" />

                </svg>

              </div>

            </button>

          </div>

        </main>


        {/* Footer */}

        <footer className="mobile-footer">

          <img
            src="/images/logo.png"
            alt="BroBizee Logo"
            className="brand-logo-img"
          />

          <span>
            Simple. Fast. Reliable.
          </span>

        </footer>

      </div>

    </div>
  );
}

